<template>
  <div class="filters-tags">
    <div v-if="has_filters" class="pr-1">Filtri attivi:</div>
    <div v-if="has_filters">
      <b-badge variant="cta" @click="remove_all_filters">elimina tutti</b-badge>
    </div>
    <div v-if="filter_carriers.length" @click="filter_carriers = []">
      <b-badge variant="tertiary">compagnie aeree</b-badge>
    </div>
    <div v-if="filter_round_trip_departure" @click="filter_round_trip_departure = ''">
      <b-badge variant="tertiary">orario di andata</b-badge>
    </div>
    <div v-if="filter_round_trip_arrival" @click="filter_round_trip_arrival = ''">
      <b-badge variant="tertiary">orario di arrivo</b-badge>
    </div>
    <div v-if="filter_return_trip_departure" @click="filter_return_trip_departure = ''">
      <b-badge variant="tertiary">orario di ritorno</b-badge>
    </div>
    <div v-if="filter_included_bags" @click="filter_included_bags = false">
      <b-badge variant="tertiary">bagagli inclusi</b-badge>
    </div>
    <div v-if="filter_extra_bags" @click="filter_extra_bags = false">
      <b-badge variant="tertiary">bagagli extra</b-badge>
    </div>
  </div>
</template>

<script>
import { are_filters_active } from '../../utilities/filters';

export default {
  name: 'filters-tags',
  components: {},
  props: {},
  computed: {
    filter_carriers: {
      get() {
        return this.$store.state.liveflight.filter_carriers;
      },
      set(value) {
        this.$store.commit('filter_carriers', value);
      },
    },
    filter_round_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_departure;
      },
      set(value) {
        this.$store.commit('filter_round_trip_departure', value);
      },
    },
    filter_round_trip_arrival: {
      get() {
        return this.$store.state.liveflight.filter_round_trip_arrival;
      },
      set(value) {
        this.$store.commit('filter_round_trip_arrival', value);
      },
    },
    filter_return_trip_departure: {
      get() {
        return this.$store.state.liveflight.filter_return_trip_departure;
      },
      set(value) {
        this.$store.commit('filter_return_trip_departure', value);
      },
    },
    filter_included_bags: {
      get() {
        return this.$store.state.liveflight.filter_included_bags;
      },
      set(value) {
        this.$store.commit('filter_included_bags', value);
      },
    },
    filter_extra_bags: {
      get() {
        return this.$store.state.liveflight.filter_extra_bags;
      },
      set(value) {
        this.$store.commit('filter_extra_bags', value);
      },
    },
    has_filters() {
      return are_filters_active();
    },
  },
  created() {},
  mounted() {},
  data() {
    return {};
  },
  methods: {
    remove_all_filters() {
      this.filter_carriers = [];
      this.filter_round_trip_departure = '';
      this.filter_round_trip_arrival = '';
      this.filter_return_trip_departure = '';
      this.filter_included_bags = false;
      this.filter_extra_bags = false;
    },
  },
};
</script>

<style lang="scss">
.filters-tags {
  display: flex;
  flex-wrap: wrap;
  .badge {
    padding: $grid-gutter-width/6 $grid-gutter-width/4;
    border-radius: $border-radius-sm;
    margin-right: $grid-gutter-width/4;
    margin-bottom: $grid-gutter-width/4;
    text-transform: uppercase;
    cursor: pointer;
    transition: $transition-base;
    &:hover {
      opacity: 0.85;
    }
    &:after {
      display: inline-block;
      line-height: 70%;
      content: '\00d7';
      font-size: 14px;
      margin-left: 6px;
      @include font-primary-regular;
    }
  }
}
</style>
